import React from 'react';
import jwt_decode from 'jwt-decode';
import "devextreme/data/odata/store";
import { createStore } from "devextreme-aspnet-data-nojquery";
import plusimg from "../../images/common/plus.png"
import exportimg from "../../images/common/xlsx.png"
import editimg from "../../images/common/pencil.png"
import onimg from "../../images/admin/on-button.png"
import offimg from "../../images/admin/off-button.png"
import {Form,Row,Modal,Button as ButtonBootstrap} from "react-bootstrap";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from 'react-toastify';    
import 'react-toastify/dist/ReactToastify.css'; 
import { exportToExcel } from '../../utils/exportMethods'; 
import ReactSelect from 'react-select';
import '../../css/Buttons.css';
import {config} from '../../constants';
import CircleSign from '../ui/CircleSign';
import ConfirmDialog from './pages/customComponents/ConfirmDialog';
import {deleteKey} from '../../utils/exportMethods';
import Maximize from '../ui/Maximize';
import Minimize from '../ui/Minimize';
import ConfirmationModal from '../ui/ConfirmationModal';
import CustomDataGrid from './pages/customComponents/CustomDataGrid';
import apiClient from '../../utils/apiClient';
import { handleErrorResponse } from '../../utils/apiClient';

const validationColor = {
  control: styles => ({ ...styles, borderLeftColor: 'red',borderLeftWidth: "4px", borderRadius:"0"}),
};

const url = config.url.URL;
const countriesLoadUrl= `${url}/GeoElementMicroservice/countriesadmindropdown`;

const dataSource = createStore({
  key: "organizationId",
  loadUrl: `${url}/MaisonMicroservice`,
  insertUrl: `${url}/InsertOrder`,
  updateUrl: `${url}/UpdateOrder`,
  deleteUrl: `${url}/MaisonMicroservice`,
  onBeforeSend: (method, ajaxOptions) => {
    ajaxOptions.headers = {
      'accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }
  },
  onAjaxError: (e) => {
    const { xhr, error } = e;
    handleErrorResponse(error || { message: 'Unknown error occurred.', response: xhr });
  }
});

const exportMaisonsToExcel = async (apiData) => {
  apiData.forEach((obj) => {
    deleteKey(obj, 'organizationId');
    deleteKey(obj, 'level');
    deleteKey(obj, 'divisionId');
  });

  const headers = [
    { header: 'Maison', key: 'name', autoFit: true },
    { header: 'Division', key: 'division', autoFit: true },
    { header: 'Country/Region', key: 'countries', width: 50 },
    { header: 'Past months open for edition', key: 'pastMonths', type: 'int', autoFit: true },
    { header: 'Status', key: 'isEnabled', autoFit: true }
  ];

  await exportToExcel(headers, apiData, 'maisons_extract', 'Maisons Extract');
};


class Maisons extends React.Component {
    constructor(props) {
        super(props);
        this.applyFilterTypes = [{
          key: 'auto',
          name: 'Immediately'
        }, {
          key: 'onClick',
          name: 'On Button Click'
        }];
       
        this.state = {
          showFilterRow: true,
          showHeaderFilter: false,
          currentFilter: this.applyFilterTypes[0].key,
          showColumnLines: false,
          showRowLines: true,
          showBorders: true,
          rowAlternationEnabled: true,
          Divisions: [],
          optionSelected: [],
          CountriesSelected: [],
          enabledValues: [],
          allValues: [],
          editCountryValues: [],
          idsSelected: null,
          can_manage_opening_input_period_per_Maisons: false,
          can_export_to_excel: false,
          fullscreen:false,
          showModal: false,
          showEditModal: false,
          showConfirmationModal: false,
          validation: true,
          nameVal:true,
          divisionVal:true,
          countryVal:true,
          countryValError:true,
          monthsVal:true,
          duplicatedValidation:true,
          selectedRowName:"",
          oldCheckValue:false,
        };
        this.dataGrid = null;
        this.onShowFilterRowChanged = this.onShowFilterRowChanged.bind(this);
        this.onShowHeaderFilterChanged = this.onShowHeaderFilterChanged.bind(this);
        this.onCurrentFilterChanged = this.onCurrentFilterChanged.bind(this);
        this.confDiag = React.createRef();
      }

      fullscreenHandler=()=>{
        this.setState(prevState =>({fullscreen: !prevState.fullscreen}));
      }


      selectedChanged(e) {
        this.setState({
          selectedRowIndex: e.component.getRowIndexByKey(e.selectedRowKeys[0])
        });
        
        console.log('hello');
      }

      // to refresh our datagrid table and close all modals
      useRefresh = () => {
        this.dataGrid.useRefresh();
        this.setState({
          showModal: false,
          showEditModal: false,
          showConfirmationModal: false,
        });
      }

      handleClose = () =>{
        this.setState({ showConfirmationModal: true });
      }
  
      closeConfirmationModal = ()=>{
        this.setState({ showConfirmationModal: false });
      }
  
      doubleCloseModals=()=>{
        this.setState({showModal: false, showEditModal: false, showConfirmationModal:false});
      }
  
      handleEditClose = () =>{
          this.setState({ showConfirmationModal: true });
      }
      
      showDisabledEnabledToast = (value) => {
        if(!this.confDiag.current.state.inEditMode) {
          if(!value) {
            toast.success('Maison has been enabled');
          }
          else {
            toast.success('Maison has been disabled');
          }
        }
        else {
          if(value) {
            toast.success('Maison has been enabled');
          }
          else {
            toast.success('Maison has been disabled');
          }
        }
      }

  openModal = () => {
     this.setState({optionSelected: this.state.enabledValues});
     this.setState({showModal:true, duplicatedValidation: true ,
      validation:true, nameVal:true, countryVal:true, divisionVal:true, monthsVal:true});
  }
  
  openEditModal = (e) => {
    console.log(e.row.data);
    this.setState({duplicatedValidation: true,showEditModal:true,  validation:true, nameVal:true, countryVal:true, divisionVal:true, monthsVal:true , countryValError:true});

    this.setState({optionSelected: null});
    const maisonName = e.row.data.name.trim();

    apiClient.get(`${url}/Organization/Countries/${e.row.data.organizationId}`)
        .then(response => {
          const data = response.data;
          const itemsSelected = data.map(obj => ({ name: obj.name, id: obj.id }));
          if (itemsSelected.length > 0) {
/*            
            let filtered = this.state.allValues.filter(obj => 
              itemsSelected.some(idObj => idObj.id === obj.value)
            );
*/            
            let editValues = this.state.allValues.filter(obj => 
              obj.isEnabled || itemsSelected.some(idObj => idObj.id === obj.value)
            );

            if (itemsSelected.length > 0) {
              const valuesIds = new Set(this.state.allValues.map((v) => v.value));
  
              itemsSelected.forEach((selectedItem) => {
                if (!valuesIds.has(selectedItem.id)) {
                  const missingOption = {
                    label: selectedItem.name,
                    value: selectedItem.id,
                    isEnabled: false,
                    canEdit: false
                  };
                  this.state.allValues.push(missingOption);
                }
              });
            }
            const optionsSelected = this.state.allValues.filter((option) =>
              itemsSelected.some((selectedItem) => selectedItem.id === option.value)
            );
            optionsSelected.sort((a, b) => a.label.localeCompare(b.label));
            this.setState({
              optionSelected:optionsSelected,
              idsSelected: itemsSelected,
              editCountryValues: editValues,
            })
          }
    });

    this.setState({selectedRowIndex: e.row.data.organizationId, selectedRowName: maisonName, oldCheckValue: e.row.data.isEnabled}); 
    this.refs.EditName.value = e.row.data.name;
    this.refs.Editdivision.value = e.row.data.divisionId;
    this.refs.Editpastmonths.value = JSON.parse(e.row.data.pastMonths).PastMonths;
    this.refs.chk_Is_Enabled.checked = e.row.data.isEnabled;
  }
  
  onExportToExcel = () => {
    apiClient.get(`${url}/MaisonMicroservice/Export`)
      .then(response => {
        const data = response.data;
        if (data) {
          exportMaisonsToExcel(data);
          toast.success('Maisons Excel export file has been generated');
        }
      });
  }

  isMonthValid = (month) => {
    if(+month >0 && +month<=24){
      return true;
    }else{
      return false
    }
  }

  onCreateMaison = () => {
    this.setState({ duplicatedValidation: true })
    let name = this.refs.Name.value.trim();
    let division = this.refs.division.value;
    let months = this.refs.pastmonths.value;
    let optSelect = this.state.optionSelected;

    if (name == "") {
      this.setState({ nameVal: false })
    } else {
      this.setState({ nameVal: true })
    }
    if (division == "") {
      this.setState({ divisionVal: false })
    } else {
      this.setState({ divisionVal: true })
    }
    if (optSelect.length === 0 || optSelect == null) {
      this.setState({ countryVal: false })
    } else {
      this.setState({ countryVal: true })
    }
    if (!this.isMonthValid(months)) {
      this.setState({ monthsVal: false })
      return;
    } else {
      this.setState({ monthsVal: true })
    }

    if (name != "" && division != "" && this.isMonthValid(months) && !(optSelect.length === 0 || optSelect == null)) {

      this.state.CountriesSelected = [];
      optSelect.map(select => {
        this.state.CountriesSelected.push(select.value);
      });

      let MaisonInfo = {
        Name: this.refs.Name.value.trim(),
        ParentOrganizationId: this.refs.division.value,
        Properties: `{"PastMonths":${this.refs.pastmonths.value}}`,
        GeoElementIds: this.state.CountriesSelected,
        OrganizationLevelId: "227496F5-2725-408C-9DDF-96F48336A4D7",
        IsEnabled: true
      };

      apiClient.post(`${url}/Organization`, MaisonInfo)
        .then(response => {
          const data = response.data;
          if (data) {
            if (data.statusCode == 400) {
              this.setState({ duplicatedValidation: false })
              return;
            } else {
              toast.success('Maison has been created');
              this.doubleCloseModals();
              this.useRefresh();
            }
          }
        });
    } else {
      this.setState({ validation: false })
      return;
    }
  }

  onEditMaison = () => {
    this.setState({ duplicatedValidation: true })
    let name = this.refs.EditName.value.trim();
    let division = this.refs.Editdivision.value;
    let months = this.refs.Editpastmonths.value;
    let optSelect = this.state.optionSelected;

    if (name == "") {
      this.setState({ nameVal: false })
    } else {
      this.setState({ nameVal: true })
    }
    if (division == "") {
      this.setState({ divisionVal: false })
    } else {
      this.setState({ divisionVal: true })
    }
    if (optSelect.length === 0 || optSelect == null) {
      this.setState({ countryVal: false })
    } else {
      this.setState({ countryVal: true })
    }
    if (!this.isMonthValid(months)) {
      this.setState({ monthsVal: false })
      return;
    } else {
      this.setState({ monthsVal: true })
    }

    if (name != "" && division != "" && this.isMonthValid(months) && !(optSelect.length === 0 || optSelect == null)) {

      this.state.CountriesSelected = [];
      optSelect.map(select => {
        this.state.CountriesSelected.push(select.value);
      });

      const contains = this.state.CountriesSelected.every(value => this.state.enabledValues.some(obj => obj.value === value));

      let MaisonInfo = {
        OrganizationId: this.state.selectedRowIndex,
        Name: this.refs.EditName.value.trim(),
        ParentOrganizationId: this.refs.Editdivision.value,
        Properties: `{"PastMonths":${this.refs.Editpastmonths.value}}`,
        GeoElementIds: this.state.CountriesSelected,
        OrganizationLevelId: "227496F5-2725-408C-9DDF-96F48336A4D7",
        IsEnabled: this.state.oldCheckValue
      };

      apiClient.put(`${url}/Organization`, MaisonInfo)
        .then(response => {
          const data = response.data;
          if (data) {
            if (data.statusCode == 400) {
              this.setState({ duplicatedValidation: false })
              return;
            } else {

              if (this.refs.chk_Is_Enabled.checked != this.state.oldCheckValue) {
                if (!contains && this.refs.chk_Is_Enabled.checked == true) { this.setState({ countryValError: false, countryVal: false }) }
                this.confDiag.current.state.status = this.refs.chk_Is_Enabled.checked
                this.confDiag.current.state.inEditMode = true;
                this.confDiag.current.state.key = this.state.selectedRowIndex;
                this.confDiag.current.handleOpenConfirmDialog();
              }
              else {
                toast.success('Maison has been updated');
                this.useRefresh();
              }
            }
          }
        });
    } else {
      this.setState({ validation: false });
      return;
    }
  }

  fetchDivisions() {
    let initialDivisions = [];
    apiClient.get(`${url}/MaisonMicroservice/Divisiondropdown`)
      .then(response => {
        const data = response.data;
        initialDivisions = data;
        this.setState({
          Divisions: initialDivisions,
        });
      });
  }

  fetchAllCountries() {
    apiClient.get(`${countriesLoadUrl}`)
      .then(response => {
        const data = response.data;
        let values = data.map(item => {
          return {
            label: item.name,
            value: item.geoElementId,
            isEnabled: item.isEnabled,
            canEdit: true
          }
        });
        let enabled = values.filter(obj => {
          return obj.isEnabled;
        });
        this.setState({ allValues: values, enabledValues: enabled });
      }).catch((error) => {
        if (error === 'Unauthorized') {
          return;
        }
        console.error(error);
      });
  }

  // Handle selection changes by identifying the added/removed option.
  // Prevent changes if the option does not have the right or is not enabled. 
  handleChange = (selected) => {
    selected = selected || [];
    const currentSelection = this.state.optionSelected || [];

    // handle "Unselect all" button
    if (selected.length === 0) {
      const nonUnselectableOptions = currentSelection.filter(
        (opt) => !opt.canEdit
      );
      if (nonUnselectableOptions.length > 0) {
        this.setState({ optionSelected: nonUnselectableOptions });
        return;
      }
    }

    // Handle individual select/unselect
    const changedOption =
      selected.find(
        (opt) => !currentSelection.some((cur) => cur.value === opt.value)
      ) ||
      currentSelection.find(
        (opt) => !selected.some((sel) => sel.value === opt.value)
      );

    if (changedOption) {
      // Logic for preventing addition of options without rights or not enabled
      if (
        (!currentSelection.some((opt) => opt.value === changedOption.value) &&
          (!changedOption.canEdit || !changedOption.isEnabled)) ||
        !changedOption.canEdit
      ) {
        return;
      }

      // Logic for allowing removal regardless of canEdit or isEnabled
      if (
        currentSelection.some((opt) => opt.value === changedOption.value) &&
        changedOption.canEdit
      ) {
        this.setState({
          optionSelected: selected.filter(
            (opt) => opt.value !== changedOption.value
          ),
        });
        return;
      }
    }

    this.setState({ optionSelected: selected });
  };
  
  componentDidMount() {
    const decoded = jwt_decode(localStorage.getItem('token'));
    this.setState({
      can_export_to_excel: decoded.can_export_to_excel === "true",
      can_manage_opening_input_period_per_Maisons : decoded.can_manage_opening_input_period_per_Maisons === "true"
    })
    this.fetchDivisions();    
    this.fetchAllCountries();
  }
  
  Checkisenabled = (e) =>{
    return e.row.data.isEnabled ;
  }

    Checkisdisabled = (e) =>{
    return !e.row.data.isEnabled ;
  }

  onDelete = (e) => {
    this.confDiag.current.state.key = e.row.data.organizationId;
    this.confDiag.current.state.status = e.row.data.isEnabled;
    this.confDiag.current.state.inEditMode = false;
    this.confDiag.current.handleOpenConfirmDialog();
  }

  render() {

    let l_Divisions = this.state.Divisions;
    let optionDivisions = l_Divisions.map((Division) =>
        <option value={Division.organizationId}>{Division.name}</option>
    );

    const columns = [
      { dataField: "isEnabled", caption: "Status", width: "110" },
      { dataField: "name", caption: "Maison", width: "50%"},
      { dataField: "division", caption: "Division", width: "50%"},
      // Add other columns specific to Profiles component
    ];
  
    const buttonColumn = [
      {text: "Edit", icon: editimg, className: "img-grid", name: "edit", onClick: this.openEditModal},
      {text: "btn_enabled", icon: onimg, hint: "Disable", visible: this.Checkisenabled, name: "delete", onClick: this.onDelete},
      {text: "btn_disabled", icon: offimg, hint: "Enable", visible: this.Checkisdisabled, name: "delete", onClick: this.onDelete},
      // Additional buttons for Profiles component
    ];

    return (
      <div className="div-body-section-details">
        <div className="div-body-section-details-header">
        <div className="div-section-title">
          <span>
            Maisons Management
          </span>
        </div>
        <div className="div-section-actions push">
          <button className={this.state.can_export_to_excel ? "btn-section-header" : "btn-section-header hidden" }  onClick={this.onExportToExcel}>
              <img className="img-section-header" src={exportimg} />
              <label>Export To Excel</label></button>
          <button  className="btn-section-header"  onClick={this.openModal}>
              <img className="img-section-header" src={plusimg} />
              <label>New Maison</label>
          </button>
        </div>
        </div>
        <div  className="div-padding-20">
          <CustomDataGrid
              dataSource={dataSource}
              keyExpr="countryId"
              ref={(ref) => (this.dataGrid = ref)}
              rowAlternationEnabled={this.state.rowAlternationEnabled}
              onSelectionChanged={this.selectionChanged}
              showFilterRow={this.state.showFilterRow}
              currentFilter={this.state.currentFilter}
              showHeaderFilter={this.state.showHeaderFilter}
              columns={columns}
              buttonColumn={buttonColumn}
            />
      </div>

      <Modal show={this.state.showModal} onHide={this.handleClose} size="maison" fullscreen={this.state.fullscreen}>
        <Modal.Header closeButton>
          <Modal.Title size="h6" >New Maison</Modal.Title>
          <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
        </Modal.Header>
        <Modal.Body>  
        {!this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>This Maison already exists, your updates cannot be saved. Please go back to Maisons Management list to edit the corresponding form.</p></Row>  } 
        {!this.state.validation && this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>Mandatory fields are missing. Saving of the Maison form is not allowed</p></Row>  } 
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="Name">
              <Form.Label className={`${this.state.nameVal ? "normal-title" : "validation-title"} font-size-12`}>Name  <CircleSign/></Form.Label>
              <Form.Control type="text" ref="Name" placeholder="Name" className={`${!this.state.nameVal && "validation-control"}`}/>
              {!this.state.nameVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row>
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="division">
              <Form.Label className={`${this.state.divisionVal ? "normal-title" : "validation-title"} font-size-12`}>Division  <CircleSign/></Form.Label>   
              <Form.Control  
                className={`select-placeholder ${!this.state.divisionVal && "validation-control"}`}
                placeholder="Division" 
                ref="division" 
                as="select"
                required
                defaultValue=""                
                >
              <option value="" hidden>Division</option>
                {optionDivisions}
              </Form.Control>
              {!this.state.divisionVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row>  
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="country">
              <Form.Label className={`${this.state.countryVal ? "normal-title" : "validation-title"} font-size-12`}>Country/Region  <CircleSign/></Form.Label>   
              <ReactSelect
                classNamePrefix={"react-select"}
                options={this.state.enabledValues}
                isMulti={true}
                styles={!this.state.countryVal && validationColor}
                closeMenuOnSelect={false}
                onChange={this.handleChange}
                value={this.state.optionSelected}
              />
              {!this.state.countryVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row>      
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="pastmonths">
              <Form.Label className={`${this.state.monthsVal ? "normal-title" : "validation-title"} font-size-12`}>Past months open for edition  <CircleSign/></Form.Label>
              <Form.Control readOnly={!this.state.can_manage_opening_input_period_per_Maisons} type="number" ref="pastmonths" placeholder="Past months" className={`${!this.state.monthsVal && "validation-control"}`} defaultValue={3}/>
              {!this.state.monthsVal && <p className="p-required">The value for the criterion “Past months open for edition” must be between 0 and 24.</p>}
            </Form.Group>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onCreateMaison}>
            Create Maison
          </ButtonBootstrap>
          <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleClose}>
            Close
          </ButtonBootstrap>
        </Modal.Footer>
      </Modal> 

      <Modal show={this.state.showEditModal} onHide={this.handleEditClose}  size="maison" fullscreen={this.state.fullscreen}>
        <Modal.Header closeButton>
          <Modal.Title size="h6" >Edit Maison</Modal.Title>
          <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
        </Modal.Header>
        <Modal.Body>  
        {!this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>This Maison already exists, your updates cannot be saved. Please go back to Maisons Management list to edit the corresponding form.</p></Row>  } 
        {!this.state.validation && this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>Mandatory fields are missing. Saving of the Maison form is not allowed</p></Row>  } 
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="Name">
              <Form.Label className={`${this.state.nameVal ? "normal-title" : "validation-title"} font-size-12`}>Name  <CircleSign/></Form.Label>
              <Form.Control type="text" ref="EditName" placeholder="Name" className={`${!this.state.nameVal && "validation-control"}`}/>
              {!this.state.nameVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row>
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="division">
              <Form.Label className={`${this.state.divisionVal ? "normal-title" : "validation-title"} font-size-12`}>Division  <CircleSign/></Form.Label>   
              <Form.Control  
                className={`select-placeholder ${!this.state.divisionVal && "validation-control"}`}
                placeholder="Division" 
                ref="Editdivision" 
                as="select" 
                required
                defaultValue=""                
                >
              <option value="" hidden>Division</option>
                {optionDivisions}
              </Form.Control>
              {!this.state.divisionVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row>  
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="country">
              <Form.Label className={`${this.state.countryVal ? "normal-title" : "validation-title"} font-size-12`}>Country/Region  <CircleSign/></Form.Label>   
              <ReactSelect
                classNamePrefix={"react-select"}
                options={this.state.editCountryValues}
                isMulti={true}
                styles={!this.state.countryVal && validationColor}
                closeMenuOnSelect={false}
                onChange={this.handleChange}
                value={this.state.optionSelected}
                />
              {!this.state.countryVal && this.state.countryValError &&<p className="p-required">Required</p>}
              {!this.state.countryVal && !this.state.countryValError && <p className="p-required">You can’t enable this Maison because it is linked to a disabled country/countries. Please remove it/them from the list or go to Country/Region administration to enable it/them.</p>}
            </Form.Group>
          </Row>      
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="pastmonths">
              <Form.Label className={`${this.state.monthsVal ? "normal-title" : "validation-title"} font-size-12`}>Past months open for edition  <CircleSign/></Form.Label>
              <Form.Control readOnly={!this.state.can_manage_opening_input_period_per_Maisons} type="number" min="0" max="24" ref="Editpastmonths" placeholder="Past months" className={`${!this.state.monthsVal && "validation-control"}`}/>
              {!this.state.monthsVal && <p className="p-required">The value for the criterion “Past months open for edition” must be between 0 and 24.</p>}
            </Form.Group>
          </Row>
          <Row>
            <Form.Group className="mb-3" controlId="formBasicCheckbox">
              <Form.Check type="checkbox" ref="chk_Is_Enabled" label="Is Enabled" />
            </Form.Group>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onEditMaison}>
            Update Maison
          </ButtonBootstrap>
          <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleEditClose}>
            Close
          </ButtonBootstrap>
        </Modal.Footer>
      </Modal>

      <ConfirmationModal show={this.state.showConfirmationModal} hide={this.closeConfirmationModal} doubleCloseModals={this.doubleCloseModals} msg="Your updates won't be saved. Are you sure you want to leave this page
          ?"/>
          
      <ConfirmDialog ref={this.confDiag} microserviceName="Organization" editfunction={this.showDisabledEnabledToast} refreshfunction={this.useRefresh} title="Can't enable Maison" msg="You can't enable this Maison because it is linked to disabled country/countries. Please remove it/them from the list or go to Country/Region administration to enable it/them."></ConfirmDialog>

      <ToastContainer position="bottom-right"/>  
      </div>
    );
  }

    onShowFilterRowChanged(e) {
      this.setState({
        showFilterRow: e.value
      });
      this.clearFilter();
    }

    onShowHeaderFilterChanged(e) {
      this.setState({
        showHeaderFilter: e.value
      });
      this.clearFilter();
    }

    onCurrentFilterChanged(e) {
      this.setState({
        currentFilter: e.value
      });
    }

    clearFilter() {
      this.dataGrid.clearFilter();
    }
}

export default Maisons;
